import { Routes } from "@angular/router";

export const AppRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('@modules/eparagon/eparagon.routing'),
  },
]